export const NewsAdministration = '/agentNewsAdministration';
export const NewsAdministrationEntry = (newsEntryId: string = '') =>
  `/agentNewsAdministration/newsEntry/${newsEntryId}`;
